import {
  Component,
  ViewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { AdvancedSearchComponent } from '../../../advanced-search/advanced-search.component'
import { ProductData } from '../../../../types/products'
import { TranslationService } from '../../../../services/translation.service'
import { ProductService } from '../../../../services/product.service'
import { Dialog } from '@angular/cdk/dialog'
import { DialogService } from '../../../../services/dialog.service'
import { ErrorService } from '../../../../services/error.service'
import { SpinnerService } from '../../../../services/spinner.service'
import { ApiError } from '../../../../types/apiError'
import { firstValueFrom } from 'rxjs'
import { ROUTES } from '../../../../constants/routes'
import { RouteService } from '../../../../services/route.service'

@Component({
  selector: 'app-add-to-catalogue',
  imports: [AdvancedSearchComponent],
  templateUrl: './add-to-catalogue.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './add-to-catalogue.component.scss',
})
export class AddToCatalogueComponent {
  translationService = inject(TranslationService)
  private productService = inject(ProductService)
  dialog = inject(Dialog)
  private errorService = inject(ErrorService)
  private dialogService = inject(DialogService)
  private spinnerService = inject(SpinnerService)
  private routeService = inject(RouteService)

  @ViewChild(AdvancedSearchComponent)
  advancedSearchComponent!: AdvancedSearchComponent

  constructor() {
    const currentRoute = this.routeService.getUserRoutes(
      ROUTES.COMPANY_PRODUCTS.title,
      `/admin/companies/${ROUTES.COMPANY_PRODUCTS.path}`,
    )
    this.routeService.setRoute(currentRoute)
  }

  async handleAddToCatalogue(product: ProductData) {
    try {
      this.spinnerService.startSpinner()
      await firstValueFrom(
        this.productService.addProductToCatalogue(product.id),
      )

      this.dialogService.showDialog(
        this.dialog,
        this.translationService.getAddToCatalogueText(),
        this.translationService.getProductAddedToCatalogueText(
          product.name,
          product.brand,
        ),
      )

      this.spinnerService.stopSpinner()

      this.advancedSearchComponent.queryPage()
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
  }
}
